import { API_URL as baseApiUrl } from "@/config/env";

export const auditUrls = {
    getScenariosForCountry: baseApiUrl + "Audit/GetScenarios",
    getPeriods: baseApiUrl + "Audit/GetPeriods",
    getScenarioAuditReport : baseApiUrl + "Audit/GetScenarioAuditReport",
    exportData: baseApiUrl + "Audit/ExportFile",
    getCommentsAndAttachments: baseApiUrl + "Audit/CommentsAndAttachments",
    downloadFile: baseApiUrl + "Define/DownloadFile",
};
export function prepareGridData(scenarioAuditData) {
    if (scenarioAuditData) {
       const rows = scenarioAuditData?.map((item, index) => {
          return {
             id: index,
             scenarioId: item.scenarioId,
             scenarioName: item.scenarioName,
             period: item.period,
             section: item.section,
             skuNumb: item.skuNumb,
             attributeName: item.attributeName,
             sectionId: item.sectionId,
             previousValue: item.previousValue,
             modifiedValue: item.modifiedValue,
             
          };
       });
       //console.log("Audit_auditUtils_prepareGridData", rows);
       return rows;
    }
    return [];
 }

 export function prepareCAGridData(CAData) {
   if (CAData) {
      const rows = CAData?.map((item, index) => {
         return {
            id: index,
            module: item.module,
            scenarioName: item.scenarioName,
            sku: item.sku,
            customerName: item.customerName,
            createdDateTime: item.createdDateTime,
            section: item.section,
            attachment: item.attachment,
            comments: item.comments
         };
      });
      return rows;
   }
   return [];
}